import { useCallback, useEffect, useState } from "react";
import type { EventOccurrence } from "@shared/types";
import { eventsApi } from "@/api/client";

export interface RangeFilter {
  start: string;
  end: string;
  personIds: string[];
  eventTypeIds: string[];
}

export function useCalendarEvents(filter: RangeFilter | null) {
  const [events, setEvents] = useState<EventOccurrence[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [version, setVersion] = useState(0);

  const refetch = useCallback(() => setVersion((v) => v + 1), []);

  useEffect(() => {
    if (!filter) return;
    let cancelled = false;
    setLoading(true);
    setError(null);
    eventsApi
      .list(filter)
      .then((res) => {
        if (!cancelled) setEvents(res.events);
      })
      .catch((err) => {
        if (!cancelled) setError(err.message || "Could not load events");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter?.start, filter?.end, filter?.personIds.join(","), filter?.eventTypeIds.join(","), version]);

  return { events, loading, error, refetch };
}
